import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import actions from "../../redux/actions";
import LoadingContent from '../../component/loading/LoadingContent'

const Section = styled.section`
  padding-top: 30px;
  width: 100% !important;
  padding-left: 0px !important;
  .txt-title center{
    margin-bottom: 10px;
  }
  .map-location{
    white-space: pre-wrap;
    text-align: center;
    font-size: 22px;
    font-weight: 500;

    img{ width: auto;}
    p{ margin-top: 30px;
      @media only screen and (max-width:768px){
        font-size: 20px;
      }
      @media only screen and (max-width : 450px){
        font-size: 20px;
      }
      @media only screen and (max-width : 376px){
        font-size: 18px;
      }
      @media only screen and (min-width : 1200px) {
        font-size: 22px;
      }
    }
  }

  .content{
      width: 100% !important;
    }
`;

export default function Index(props) {
  const [content, setContent] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.master.setPath("/contact-us"));
    setContent(true)
  }, [])

  return (
    <Section
      className={"section-contact"}
    >
      <div className="container">
        {!content ? <LoadingContent />
          :
          <>
            <div className="section-heading">ติดต่อสอบถาม</div>
            <div className="map-location">
              <a href="https://goo.gl/maps/tnaBP7VrCKU5h4py5" target="_blank"><img src="./image/map_location.png" alt="map-location" /></a>
              <p>ศูนย์สนับสนุนข้อมูลการแจ้งเตือนภัย ศบภ.ทร. กรมอุทกศาสตร์ กองทัพเรือ <br />
                เลขที่ 222 ถนนริมทางรถไฟเก่า แขวงบางนา เขตบางนา กรุงเทพมหานคร 10260 <br />
                โทรศัพท์ (02) 475 2117, (02) 745 4435
              </p>
            </div>
          </>
        }
      </div>
    </Section>
  )
}
